<template>
<div class="breadcrumbs">
    <div class="content-width">
        <h1>{{ $route.name }}</h1>
    </div>
</div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style>
  .breadcrumbs {
    background: var(--primary-color);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 22px 0px;
  }

  .breadcrumbs h1 {
      color: white;
      margin: 0px;
  }
</style>


// WEBPACK FOOTER //
// src/components/breadcrumbs.vue